(function () {
  //ADD PRODUCT IN REQUEST A QUOTE FORM AND POPULATE FORM
  const isRequestQuotePage = window.location.pathname.includes(
    "pages/cart"
  );

  function cloneProductFieldHandle() {
    const productsDivs = document.querySelectorAll(
      'div[id*="product-container"]'
    );
    if (productsDivs.length >= 1) {
      productsDivs.forEach((div, index) => {
        const newDiv = div.cloneNode(true);
        const newInput = newDiv.querySelector('input[id*="contact_product"]');
        const newLabel = newDiv.querySelector("label");
        const newRemoveItemButton = newDiv.querySelector("#remove-product");
        const lastProductDiv = productsDivs.length - 1;
        const newProductIndex = productsDivs.length + 1;
        newDiv.id = `product-container-${newProductIndex}`;
        if (index === lastProductDiv) {
          newLabel.outerHTML = `<label for="contact_product-${newProductIndex}">Product ${newProductIndex}</label>`;
          newInput.id = `contact_product-${newProductIndex}`;
          newInput.name = `contact[product-${newProductIndex}]`;
          newInput.placeholder = `Product #${newProductIndex}`;
          newInput.value = "";
          newRemoveItemButton.addEventListener("click", () =>
            removeProductHandle(newRemoveItemButton)
          );
          newInput.removeAttribute("inserted-by-quote");
          div.insertAdjacentElement("afterend", newDiv);
        }
      });
    }
  }

  function insertNewProductFromStorage(productHandle) {
    const productsDivs = document.querySelectorAll(
      'div[id*="product-container"]'
    );
    productsDivs.forEach((div, index) => {
      const newDiv = div.cloneNode(true);
      const newInput = newDiv.querySelector('input[id*="contact_product"]');
      const newLabel = newDiv.querySelector("label");
      const lastProductDiv = productsDivs.length - 1;
      const newProductIndex = productsDivs.length + 1;
      newDiv.id = `product-container-${newProductIndex}`;
      if (index === lastProductDiv) {
        newLabel.outerHTML = `<label for="contact_product-${newProductIndex}">Product ${newProductIndex}</label>`;
        newInput.id = `contact_product-${newProductIndex}`;
        newInput.name = `contact[product-${newProductIndex}]`;
        newInput.placeholder = `Product #${newProductIndex}`;
        newInput.value = productHandle;
        newInput.setAttribute("inserted-by-quote", "true");
        div.insertAdjacentElement("afterend", newDiv);
      }
    });
  }

  function populateInputs() {
    const storageFormValues = window.localStorage.getItem("formValues");
    if (storageFormValues) {
      FormValuesObject = JSON.parse(storageFormValues);
      const form = document.getElementById("contact_form");
      const firstName = form.querySelector("#contact_name_contact");
      const lastName = form.querySelector("#contact_last_name_contact");
      const email = form.querySelector("#contact_email_contact");
      const phoneNumber = form.querySelector("#contact_phone-number");
      const message = form.querySelector("#contact_message");
      firstName.value = FormValuesObject.firstName;
      lastName.value = FormValuesObject.lastName;
      email.value = FormValuesObject.email;
      phoneNumber.value = FormValuesObject.phoneNumber;
      message.value = FormValuesObject.message;
    }
  }

  function reorderInputsProducts() {
    const productsInputContainer = document.querySelectorAll(
      'div[id*="product-container"]'
    );
    if (productsInputContainer) {
      productsInputContainer.forEach((div, index) => {
        const label = div.querySelector("label");
        const input = div.querySelector("input");
        const newIndex = index + 1;
        if (index === 0) {
          div.id = "product-container";
          label.outerHTML = '<label for="contact_product-1">Product 1</label>';
          input.id = "contact_product-1";
          input.placeholder = "Product #1";
        }
        if (index !== 0) {
          div.id = `product-container-${newIndex}`;
          label.outerHTML = `<label for="contact_product-${newIndex}">Product ${newIndex}</label>`;
          input.id = `contact_product-${newIndex}`;
          input.placeholder = `Product #${newIndex}`;
        }
      });
    }
  }

  function removeProductHandle(removeButton) {
    const inputDiv = removeButton.parentNode;
    const divToRemove = inputDiv.parentNode;
    const input = inputDiv.querySelector("input");
    const inputInsertedByQuote = input.getAttribute("inserted-by-quote");
    const productsToQuoteStorage =
      window.localStorage.getItem("productsToQuote");
    const productsDivs = document.querySelectorAll(
      'div[id*="product-container"]'
    );

    if (inputInsertedByQuote && productsToQuoteStorage) {
      const inputValue = input.value;
      let productsToQuoteStorageArray = JSON.parse(productsToQuoteStorage);
      productsToQuoteStorageArray = productsToQuoteStorageArray.filter(
        (product) => product.productHandle !== inputValue
      );
      // set local storage item
      window.localStorage.setItem(
        "productsToQuote",
        JSON.stringify(productsToQuoteStorageArray)
      );
      const allGetQuoteButtons = document.querySelectorAll(
        "[get-a-quote-header]"
      );
      allGetQuoteButtons.forEach((button, index) => {
        const span = button.querySelector("span");
        span.innerHTML = `(${productsToQuoteStorageArray.length})`;
      });
    }

    if (productsDivs.length >= 2) {
      //remove item
      divToRemove.remove();

      //reorder items
      reorderInputsProducts();
    }
    if (productsDivs.length == 1) {
      productsDivs.forEach((div, index) => {
        const uniqueInput = div.querySelector("input");
        uniqueInput.value = "";
      });
    }
  }

  if (isRequestQuotePage) {
    const addProductButton = document.querySelector("#add-product");
    addProductButton.addEventListener("click", () => {
      cloneProductFieldHandle();
    });
    const productsToQuoteStorage =
      window.localStorage.getItem("productsToQuote");
    if (productsToQuoteStorage) {
      const productsToQuoteStorageArray = JSON.parse(productsToQuoteStorage);
      productsToQuoteStorageArray.forEach((product, index) => {
        if (index === 0) {
          const productInput = document.querySelector(
            'input[id*="contact_product"]'
          );
          productInput.value = product.productHandle;
          productInput.setAttribute("inserted-by-quote", "true");
        }
        if (index !== 0) {
          insertNewProductFromStorage(product.productHandle);
        }
      });
    }

    // ADD REMOVE PRODUCT FUNCTION
    const removeButtons = document.querySelectorAll("#remove-product");
    removeButtons.forEach((removeButton, index) => {
      removeButton.addEventListener("click", () =>
        removeProductHandle(removeButton)
      );
    });

    //POPULATE INPUTS WITH USER'S FORM DATA

    populateInputs();

    //GET FORM VALUES WHEN USER EXIT PAGE

    window.addEventListener("beforeunload", function (event) {
      const form = document.getElementById("contact_form");
      if (form) {
        // SET ANOTHERS FIELDS (EXCEPT PRODUCTS)
        const firstName = form.querySelector("#contact_name_contact").value;
        const lastName = form.querySelector("#contact_last_name_contact").value;
        const email = form.querySelector("#contact_email_contact").value;
        const phoneNumber = form.querySelector("#contact_phone-number").value;
        const message = form.querySelector("#contact_message").value;
        const formObject = {
          firstName,
          lastName,
          email,
          phoneNumber,
          message,
        };
        window.localStorage.setItem("formValues", JSON.stringify(formObject));

        const productsInputs = document.querySelectorAll(
          'input[id*="contact_product"]'
        );
        if (productsInputs.length >= 1) {
          productsObj = [];
          productsInputs.forEach((productInput, index) => {
            if (productInput.value !== "") {
              productsObj.push({
                productHandle: productInput.value,
              });
            }
          });
        }
        window.localStorage.setItem(
          "productsToQuote",
          JSON.stringify(productsObj)
        );
      }
    });
  }

  //HIDE PRICE AND ADD BUTTON IN RECOMMENDATIONS CARROUSEL IF METAFIELD IS TRUE
  function hidePriceAndAddButton(product) {
    const formButton = product.querySelector(
      `div [x-ref="formContainer"] form button`
    );
    const priceContainer = product.querySelector("div [price-data]");
    formButton.style.display = "none";
    priceContainer.style.display = "none";
  }

  function insertAddToQuoteButton(product, productHandle) {
    const form = product.querySelector(`div [x-ref="formContainer"] form`);
    const newButton = `<a id="add-to-quote" handle="${productHandle}" class="!w-full btn btn--secondary btn--small hover:underline btn--secondary">ADD TO QUOTE</a>`;

    form.insertAdjacentHTML("afterend", newButton);
    const addToQuoteButton = product.querySelector("#add-to-quote");

    const producstToQuote = window.localStorage.getItem("productsToQuote");

    if (producstToQuote) {
      productsToQuoteStorageArray = JSON.parse(producstToQuote);
      const hasHandle = productsToQuoteStorageArray.some(
        (product) => product.productHandle === productHandle
      );
      if (hasHandle) {
        addToQuoteButton.innerHTML = "Added to Order ✓";
      }
    }

    addToQuoteButton.addEventListener("click", () => {
      addToQuoteHandle(productHandle, addToQuoteButton);
    });
  }

  setTimeout(async () => {
    const recommendationsSlider = document.querySelector(
      "[recommendation-products-data]"
    );
    const recentProductsSlider = document.querySelector(
      "[recent-products-data]"
    );

    const upsellProductsSlider = document.querySelector(
      "[upsell-products-slider]"
    );

    if (recommendationsSlider) {
      const products = recommendationsSlider.querySelectorAll("[handle]");
      for (const product of products) {
        const productHandle = product.getAttribute("handle");

        try {
          const response = await fetch(
            `/products/${productHandle}?view=custom-data`
          );
          const textData = await response.text();
          const data = JSON.parse(textData);
          if (data.hide_add_to_cart_and_price == "true") {
            hidePriceAndAddButton(product);
          }
          if (data.show_quote_button == "true") {
            insertAddToQuoteButton(product, productHandle);
          }
        } catch (error) {
          console.error("Failed to fetch product data:", error);
        }
      }
    }
    if (recentProductsSlider) {
      const products = recentProductsSlider.querySelectorAll("[handle]");
      for (const product of products) {
        const productHandle = product.getAttribute("handle");

        try {
          const response = await fetch(
            `/products/${productHandle}?view=custom-data`
          );
          const textData = await response.text();
          const data = JSON.parse(textData);
          if (data.hide_add_to_cart_and_price == "true") {
            hidePriceAndAddButton(product);
          }
          if (data.show_quote_button == "true") {
            insertAddToQuoteButton(product, productHandle);
          }
        } catch (error) {
          console.error("Failed to fetch product data:", error);
        }
      }
    }
    // if (upsellProductsSlider) {
    //   const productsDiv = upsellProductsSlider.querySelectorAll("[handle]");
    //   let productsWithMetafield = [];
    //   for (const product of productsDiv) {
    //     const productHandle = product.getAttribute("handle");

    //     try {
    //       const response = await fetch(
    //         `/products/${productHandle}?view=custom-data`
    //       );
    //       const textData = await response.text();
    //       const data = JSON.parse(textData);
    //       if (data.hide_add_to_cart_and_price == "true") {
    //         productsWithMetafield.push(product);
    //       }
    //     } catch (error) {
    //       console.error("Failed to fetch product data:", error);
    //     }
    //   }
    //   if (productsDiv.length === productsWithMetafield.length) {
    //     const accordionToHide = upsellProductsSlider.parentNode.parentNode;
    //     accordionToHide.style.display = "none";
    //     return;
    //   }
    //   for (const producWithMetafield of productsWithMetafield) {
    //     producWithMetafield.style.display = "none";
    //   }
    // }
  }, 1000);

  // ADD TO QUOTE EVENT AND SET LOCAL STORAGE

  function updateGetAQuoteButton() {
    const allGetAQuoteButtons = document.querySelectorAll(
      "[get-a-quote-header]"
    );
    if (allGetAQuoteButtons.length >= 1) {
      const productsToQuoteStorage =
        window.localStorage.getItem("productsToQuote");
      if (!productsToQuoteStorage) {
        for (const getAQuoteButton of allGetAQuoteButtons) {
          const spanProductsToQuoteQuantity =
            getAQuoteButton.querySelector("span");
          if (spanProductsToQuoteQuantity) {
            spanProductsToQuoteQuantity.remove();
          }
        }
      }
      if (productsToQuoteStorage) {
        const productsToQuoteStorageArray = JSON.parse(productsToQuoteStorage);
        const productsToQuoteQuantity = productsToQuoteStorageArray.length;
        for (const getAQuoteButton of allGetAQuoteButtons) {
          if (productsToQuoteQuantity > 0) {
            getAQuoteButton.innerHTML = "Complete Your Order";
          }
          const spanProductsToQuoteQuantity =
            getAQuoteButton.querySelector("span");
          if (spanProductsToQuoteQuantity) {
            spanProductsToQuoteQuantity.innerHTML = `(${productsToQuoteQuantity})`;
          }
          if (!spanProductsToQuoteQuantity) {
            getAQuoteButton.innerHTML = `${getAQuoteButton.innerHTML}&nbsp <span>(${productsToQuoteQuantity})</span>`;
          }
        }
      }
    }
  }

  function addToQuoteHandle(productHandle, addQuoteButton) {
    const productsToQuoteStorage =
      window.localStorage.getItem("productsToQuote");
    if (!productsToQuoteStorage) {
      window.localStorage.setItem(
        "productsToQuote",
        `[{"productHandle": "${productHandle}"}]`
      );
      updateGetAQuoteButton();
    }
    if (productsToQuoteStorage) {
      const productsToQuoteStorageArray = JSON.parse(productsToQuoteStorage);
      const hasHandle = productsToQuoteStorageArray.some(
        (product) => product.productHandle === productHandle
      );
      if (hasHandle) {
        addQuoteButton.innerHTML = "Added to Order ✓";
        return;
      }
      productsToQuoteStorageArray.push({ productHandle: productHandle });
      window.localStorage.setItem(
        "productsToQuote",
        JSON.stringify(productsToQuoteStorageArray)
      );
      updateGetAQuoteButton();
    }
    addQuoteButton.innerHTML = "Added to Order ✓";
  }

  const addToQuoteButtons = document.querySelectorAll("#add-to-quote");
  if (addToQuoteButtons.length >= 1) {
    for (const addQuoteButton of addToQuoteButtons) {
      const productHandle = addQuoteButton.getAttribute("handle");
      addQuoteButton.addEventListener("click", () =>
        addToQuoteHandle(productHandle, addQuoteButton)
      );
    }
  }

  updateGetAQuoteButton();

  // SET  "Added to Quote ✓" ON THE BUTTON WHEN THE PRODUCT IS ALREADY IN THE QUOTE
  const allAddToQuoteButtons = document.querySelectorAll("#add-to-quote");
  const producstToQuote = window.localStorage.getItem("productsToQuote");
  if (allAddToQuoteButtons && producstToQuote) {
    for (const addToQuoteButton of allAddToQuoteButtons) {
      const productHandle = addToQuoteButton.getAttribute("handle");
      if (producstToQuote) {
        productsToQuoteStorageArray = JSON.parse(producstToQuote);
        const hasHandle = productsToQuoteStorageArray.some(
          (product) => product.productHandle === productHandle
        );
        if (hasHandle) {
          addToQuoteButton.innerHTML = "Added to Order ✓";
        }
      }
    }
  }
})();

